import { ParkingType, UserType } from './utilTypes';

export const isUserIdentityVerified = (user: UserType | null) => {
  if (!user) return false;
  return user.stripeVerificationSession?.status === 'verified';
};

export const isUserIdentityProcessing = (user: UserType | null) => {
  if (!user) return false;
  return user.stripeVerificationSession?.status === 'processing';
};

export const isUserIdentityFailed = (user: UserType | null) => {
  if (!user) return false;
  return user.stripeVerificationSession?.status === 'failed';
};

const PERMANENT_FAILURE_CODES = new Set([
  'document_type_not_supported',
  'document_country_not_supported',
  'under_supported_age',
  'selfie_manipulated',
]);

export const isIdentityFailurePermanent = (user: UserType | null) => {
  const code = user?.stripeVerificationSession?.lastError;
  return !!code && PERMANENT_FAILURE_CODES.has(code);
};

export const isUserParkingRequestApproved = (
  user: UserType | null,
  parking: ParkingType
) => {
  if (!user) {
    return false;
  }

  if (user.userParkings) {
    const foundParking = user.userParkings.find(
      (userParking) => userParking.parking.id === parking.id
    );

    if (!foundParking) {
      return false;
    }

    return foundParking.status === 'approved';
  }

  return false;
};
